import ShopService from '@/services/shop.service';
import axios from "axios";

export const shopModule = {
    namespaced: true,
    state: {
        requests: [],
        category: {},
        categories: new Map(),
        product: {},
        products: new Map(),
        order: {},
        orders: new Map(),
    },
    actions: {
        clearRequest({state}, name) {
            state.requests = state.requests.filter(obj => obj.requestName !== name);
        },
        makeOrCancelRequest({state}, name) {
            const requestExist = state.requests.find((item) => {
                return item.requestName === name ? item : null
            })

            if (requestExist)
                requestExist.cancel()

            const axiosSource = axios.CancelToken.source();

            state.requests = state.requests.filter(obj => obj.requestName !== name);
            state.requests.push({requestName: name, cancel: axiosSource.cancel});

            return axiosSource;
        },
        async createCategory({commit, dispatch}, data) {
            const axiosSource = await dispatch('makeOrCancelRequest', "createCategory");
            return ShopService.createCategory(axiosSource, data).then(
                async data => {
                    commit('insertCategory', data);
                    await dispatch('clearRequest', "createCategory");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async updateCategory({commit, dispatch}, data) {
            const axiosSource = await dispatch('makeOrCancelRequest', "updateCategory");
            return ShopService.updateCategory(axiosSource, data).then(
                async data => {
                    commit('updateCategoryData', data);
                    await dispatch('clearRequest', "updateCategory");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async deleteCategory({commit, dispatch}, categoryId) {
            const axiosSource = await dispatch('makeOrCancelRequest', "deleteCategory");
            return ShopService.deleteCategory(axiosSource, categoryId).then(
                async data => {
                    commit('removeCategoryFromList', categoryId);
                    await dispatch('clearRequest', "deleteCategory");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async listCategories({commit, dispatch}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "listCategories");
            return ShopService.listCategories(axiosSource).then(
                async data => {
                    commit('updateCategoriesList', data);
                    await dispatch('clearRequest', "listCategories");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async createProduct({commit, dispatch}, data) {
            const axiosSource = await dispatch('makeOrCancelRequest', "createProduct");
            return ShopService.createProduct(axiosSource, data).then(
                async data => {
                    commit('insertProduct', data);
                    await dispatch('clearRequest', "createProduct");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async updateProduct({commit, dispatch}, data) {
            const axiosSource = await dispatch('makeOrCancelRequest', "updateProduct");
            return ShopService.updateProduct(axiosSource, data).then(
                async data => {
                    commit('updateProductData', data);
                    await dispatch('clearRequest', "updateProduct");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async deleteProduct({commit, dispatch}, productId) {
            const axiosSource = await dispatch('makeOrCancelRequest', "deleteProduct");
            return ShopService.deleteProduct(axiosSource, productId).then(
                async data => {
                    commit('removeProductFromList', productId);
                    await dispatch('clearRequest', "deleteProduct");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async getProduct({commit, dispatch}, productId) {
            const axiosSource = await dispatch('makeOrCancelRequest', "getProduct");
            return ShopService.getProduct(axiosSource, productId).then(
                async data => {
                    commit('updateActiveProduct', data);
                    await dispatch('clearRequest', "getProduct");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async listProducts({commit, dispatch}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "listProducts");
            return ShopService.listProducts(axiosSource).then(
                async data => {
                    commit('updateProductsList', data);
                    await dispatch('clearRequest', "listProducts");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async listOrders({commit, dispatch}, productId) {
            const axiosSource = await dispatch('makeOrCancelRequest', "listOrders");
            return ShopService.listOrders(axiosSource, productId).then(
                async data => {
                    commit('updateOrdersList', data);
                    await dispatch('clearRequest', "listOrders");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async getProductLanding({commit, dispatch}, productId) {
            const axiosSource = await dispatch('makeOrCancelRequest', "getProductLanding");
            return ShopService.getProductLanding(axiosSource, productId).then(
                async data => {
                    commit('updateActiveProduct', data);
                    await dispatch('clearRequest', "getProductLanding");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async createOrder({commit, dispatch}, productId) {
            const axiosSource = await dispatch('makeOrCancelRequest', "createOrder");
            return ShopService.createOrder(axiosSource, productId).then(
                async data => {
                    commit('updateActiveOrder', data);
                    await dispatch('clearRequest', "createOrder");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async listCategoriesLanding({commit, dispatch}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "listCategoriesLanding");
            return ShopService.listCategoriesLanding(axiosSource).then(
                async data => {
                    commit('updateCategoriesList', data);
                    await dispatch('clearRequest', "listCategoriesLanding");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async listProductsLanding({commit, dispatch}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "listProductsLanding");
            return ShopService.listProductsLanding(axiosSource).then(
                async data => {
                    commit('updateProductsList', data);
                    await dispatch('clearRequest', "listProductsLanding");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async getOrders({commit, dispatch}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "getOrders");
            return ShopService.getOrders(axiosSource).then(
                async data => {
                    commit('updateOrdersList', data);
                    await dispatch('clearRequest', "getOrders");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
    },
    mutations: {
        updateCategoriesList(state, data) {
            state.categories = new Map();

            for (const entity of data) {
                state.categories.set(entity.id, entity)
            }
        },
        insertCategory(state, data) {
            state.categories.set(data.id, data)
        },
        updateCategoryData(state, data) {
            state.categories.set(data.id, data)
        },
        removeCategoryFromList(state, productId) {
            state.categories.delete(productId)
        },
        updateActiveCategory(state, data) {
            state.category = data;
        },
        updateProductsList(state, data) {
            state.products = new Map();

            for (const entity of data) {
                state.products.set(entity.id, entity)
            }
        },
        insertProduct(state, data) {
            state.products.set(data.id, data)
        },
        updateProductData(state, data) {
            state.products.set(data.id, data)
        },
        removeProductFromList(state, productId) {
            state.products.delete(productId)
        },
        updateActiveProduct(state, data) {
            state.product = data;
        },
        updateOrdersList(state, data) {
            state.orders = new Map();

            for (const entity of data) {
                state.orders.set(entity.id, entity)
            }
        },
        updateActiveOrder(state, data) {
            state.order = data;
        }
    }
};